import { STSchemeColorVal } from '@tencent/slide-sdk-pb-model';
import { resolveColorChoice } from '../props/common/color-props/color-resolve';
import type { ICTColorDmlA } from '@tencent/slide-sdk-pb-model';
import type { IPageDataModel } from '../model/page-data-model';

export enum HLinkType {
    Normal = 'normal',
    Followed = 'followed',
}

export interface IColorManager {
    resolveColor(colorData: ICTColorDmlA, page: IPageDataModel): ICTColorDmlA;
    getHLinkColor(page: IPageDataModel, linkType?: HLinkType): ICTColorDmlA;
}

export class ColorManager implements IColorManager {
    /**
     * 给定 color 的原始数据以及 page，返回处理后的色值
     */
    public resolveColor(colorData: ICTColorDmlA, page: IPageDataModel): ICTColorDmlA {
        const schemeColorMap = page.getPageContext().getThemeContext?.().getSchemeColorMap();
        return { srgbClr: resolveColorChoice(colorData, schemeColorMap).srgbClr };
    }

    /**
     * 获取主题链接色
     * @param page 指定获取哪一页上的主题链接色
     * @param {HLinkType} linkType 指定获取链接色类型（链接色/使用过的链接色），默认获取链接色
     * @returns 处理后的 srgbClr
     */
    public getHLinkColor(page: IPageDataModel, linkType: HLinkType = HLinkType.Normal): ICTColorDmlA {
        const schemeClrVal = {
            [HLinkType.Normal]: STSchemeColorVal.hlink,
            [HLinkType.Followed]: STSchemeColorVal.folHlink,
        }[linkType];
        const colorData: ICTColorDmlA = {
            schemeClr: { val: schemeClrVal },
        };
        return this.resolveColor(colorData, page);
    }
}
